import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import AnimationEffects from "%/dynamic-component-editor/options/animation-effects";

export default class AnimationEffectsOptions extends BaseOptionsBundle {
  optionTitle = "Animation Effects";
  static optionClassName = "i-dynamic-animation-effects";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new AnimationEffects(undefined, hideFromInspector["animation-effects"] ?? false),
    ]);
  }
}
